import { render } from "./CourseGroupSettings.vue?vue&type=template&id=ba1c0470"
import script from "./CourseGroupSettings.vue?vue&type=script&lang=js"
export * from "./CourseGroupSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__